import { dew as _anyDew } from "./any";
import { dew as _booleanDew } from "./boolean";
import { dew as _numberDew } from "./number";
import { dew as _stringDew } from "./string";
import { dew as _unknownDew } from "./unknown";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.unknown = exports.string = exports.number = exports.boolean = exports.any = void 0;
  var any_1 = _anyDew();
  Object.defineProperty(exports, "any", {
    enumerable: true,
    get: function () {
      return any_1.any;
    }
  });
  var boolean_1 = _booleanDew();
  Object.defineProperty(exports, "boolean", {
    enumerable: true,
    get: function () {
      return boolean_1.boolean;
    }
  });
  var number_1 = _numberDew();
  Object.defineProperty(exports, "number", {
    enumerable: true,
    get: function () {
      return number_1.number;
    }
  });
  var string_1 = _stringDew();
  Object.defineProperty(exports, "string", {
    enumerable: true,
    get: function () {
      return string_1.string;
    }
  });
  var unknown_1 = _unknownDew();
  Object.defineProperty(exports, "unknown", {
    enumerable: true,
    get: function () {
      return unknown_1.unknown;
    }
  });
  return exports;
}